'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin: auto;\n  position: relative;\n  ', '\n  padding: 25px;\n  border-radius: 5px;\n'], ['\n  margin: auto;\n  position: relative;\n  ', '\n  padding: 25px;\n  border-radius: 5px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  font-weight: 500;\n  color: ', ';\n  text-align: left;\n  padding-left: 6px;\n  padding-bottom: 30px;\n'], ['\n  font-size: 12px;\n  font-weight: 500;\n  color: ', ';\n  text-align: left;\n  padding-left: 6px;\n  padding-bottom: 30px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _chart = require('chart.js');

var _chart2 = _interopRequireDefault(_chart);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ChartWrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.chartBorder ? 'box-shadow: 0 9px 15px -10px rgba(0,0,0,0.5);' : '';
});

var DivTitle = _styledComponents2.default.div(_templateObject2, _color2.default.blue_main);

var MozartLineChart = function (_Component) {
  _inherits(MozartLineChart, _Component);

  function MozartLineChart(props) {
    _classCallCheck(this, MozartLineChart);

    var _this = _possibleConstructorReturn(this, (MozartLineChart.__proto__ || Object.getPrototypeOf(MozartLineChart)).call(this, props));

    _this.state = {
      legend: '',
      width: 0,
      height: 0
    };

    _this._chart = null;
    _this.Chart = _chart2.default;

    _this.Chart.plugins.register({
      afterDraw: function afterDraw(chartInstance) {
        if (chartInstance.config.options.showDatapoints) {
          var helpers = _this.Chart.helpers;
          var ctx = chartInstance.chart.ctx;
          var fontColor = helpers.getValueOrDefault(chartInstance.config.options.showDatapoints.fontColor, chartInstance.config.options.defaultFontColor);

          // render the value of the chart above the bar
          ctx.font = _this.Chart.helpers.fontString(_this.Chart.defaults.global.defaultFontSize, 'normal', _this.Chart.defaults.global.defaultFontFamily);
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';
          ctx.fillStyle = fontColor;

          var xLargeVariable = chartInstance.config.options.xLargeVariable !== undefined ? chartInstance.config.options.xLargeVariable : 0;
          var yLargeVariable = chartInstance.config.options.yLargeVariable !== undefined ? chartInstance.config.options.yLargeVariable : 12;
          var xSmallVariable = chartInstance.config.options.xSmallVariable !== undefined ? chartInstance.config.options.xSmallVariable : 20;
          var ySmallVariable = chartInstance.config.options.ySmallVariable !== undefined ? chartInstance.config.options.ySmallVariable : 12;
          chartInstance.data.datasets.forEach(function (dataset) {
            // find scale
            var max = dataset.data.reduce(function (numb1, numb2) {
              return Math.max(numb1, numb2);
            });
            var min = dataset.data.reduce(function (numb1, numb2) {
              return Math.min(numb1, numb2);
            });

            for (var count = 0; count < dataset.data.length; count++) {
              var model = dataset._meta[Object.keys(dataset._meta)[0]].data[count]._model;
              var scaleMax = dataset._meta[Object.keys(dataset._meta)[0]].data[count]._yScale.maxHeight;
              var xPos = model.x;
              var yPos = (scaleMax - model.y) / scaleMax >= 0.93 ? model.y + 20 : model.y - 5;
              if (max - min > 70 && max === dataset.data[count] || dataset.data[count] !== 0 && min === 0) {
                xPos = xPos + xLargeVariable;
                yPos = yPos + yLargeVariable;
              } else {
                xPos = xPos + xSmallVariable;
                yPos = yPos + ySmallVariable;
              }
              ctx.fillStyle = fontColor;
              ctx.fillText(dataset.data[count], xPos, yPos);
            }
          });
        }
        if (chartInstance.options.centertext && chartInstance.options.centertext.name && chartInstance.options.centertext.afterdraw) {
          _this.drawCenterText(chartInstance);
        }
        if (chartInstance.options.lefttext && chartInstance.options.lefttext.name && chartInstance.options.lefttext.afterdraw) {
          _this.drawLeftText(chartInstance);
        }
        if (chartInstance.options.righttext && chartInstance.options.righttext.name && chartInstance.options.righttext.afterdraw) {
          _this.drawRightText(chartInstance);
        }
      },
      beforeDraw: function beforeDraw(chartInstance) {
        if (chartInstance.options.centertext && chartInstance.options.centertext.name && chartInstance.options.centertext.beforedraw) {
          _this.drawCenterText(chartInstance);
        }
        if (chartInstance.options.lefttext && chartInstance.options.lefttext.name && chartInstance.options.lefttext.beforedraw) {
          _this.drawLeftText(chartInstance);
        }
        if (chartInstance.options.righttext && chartInstance.options.righttext.name && chartInstance.options.righttext.beforedraw) {
          _this.drawRightText(chartInstance);
        }
      }
    });
    return _this;
  }

  _createClass(MozartLineChart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.width === 0 && this.state.height === 0) {
        this.initChart();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.state.width === 0 && this.state.height === 0) {
        this.initChart();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateChart();
    }
  }, {
    key: 'drawCenterText',
    value: function drawCenterText(chartInstance) {
      var width = chartInstance.chart.width;
      var height = chartInstance.chart.height;
      var ctx = chartInstance.chart.ctx;

      ctx.font = (chartInstance.options.centertext.fontSize ? chartInstance.options.centertext.fontSize + 'px' : (height / 70).toFixed(2) + 'em') + ' sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = chartInstance.options.centertext.fontColor ? chartInstance.options.centertext.fontColor : '#000000';

      var text = chartInstance.options.centertext.name;
      var textX = Math.round((width - ctx.measureText(text).width) / 2);
      var textY = height / 4;
      ctx.fillText(text, textX, textY);
      if (chartInstance.options.centertext.subtext && chartInstance.options.centertext.subtext.name) {
        var ctx1 = chartInstance.chart.ctx;
        ctx1.font = (chartInstance.options.centertext.subtext.fontWeight ? chartInstance.options.centertext.subtext.fontWeight : 'lighter') + ' ' + (chartInstance.options.centertext.subtext.fontSize ? chartInstance.options.centertext.subtext.fontSize + 'px' : (height / 140).toFixed(2) + 'em') + ' sans-serif';
        ctx1.textBaseline = 'middle';
        ctx1.fillStyle = chartInstance.options.centertext.subtext.fontColor ? chartInstance.options.centertext.subtext.fontColor : '#000000';
        var subText = chartInstance.options.centertext.subtext.name;
        var subTextX = Math.round((width - ctx.measureText(subText).width) / 2);
        var subTextY = height / 2 + 20;
        ctx1.fillText(subText, subTextX, subTextY);
      }
    }
  }, {
    key: 'drawLeftText',
    value: function drawLeftText(chartInstance) {
      var height = chartInstance.chart.height;
      var ctx = chartInstance.chart.ctx;

      ctx.font = (chartInstance.options.lefttext.fontWeight ? chartInstance.options.lefttext.fontWeight : 'lighter') + ' ' + chartInstance.options.lefttext.fontSize + ' sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = chartInstance.options.lefttext.fontColor ? chartInstance.options.lefttext.fontColor : '#000000';

      var text = chartInstance.options.lefttext.name;
      var textX = 5;
      var textY = height / 4;
      ctx.fillText(text, textX, textY);
    }
  }, {
    key: 'drawRightText',
    value: function drawRightText(chartInstance) {
      var width = chartInstance.chart.width;
      var height = chartInstance.chart.height;
      var ctx = chartInstance.chart.ctx;

      ctx.font = (chartInstance.options.righttext.fontWeight ? chartInstance.options.righttext.fontWeight : 'lighter') + ' ' + chartInstance.options.righttext.fontSize + ' sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = chartInstance.options.righttext.fontColor ? chartInstance.options.righttext.fontColor : '#000000';

      var text = chartInstance.options.righttext.name;
      var textX = Math.round(width - ctx.measureText(text).width) - 5;
      var textY = height / 4;
      ctx.fillText(text, textX, textY);
    }
  }, {
    key: 'initChart',
    value: function initChart() {
      var wrapper = _reactDom2.default.findDOMNode(this.refs.chartWrapper);
      var width = wrapper.clientWidth;
      var height = wrapper.clientHeight;
      if (this._chart && this.props.responsive) {
        this._chart.chart.width = width;
        this._chart.chart.height = height;
      }
      this.setState({
        width: width === 0 ? 100 : width,
        height: height === 0 ? 100 : height
      });
      this.setState({ width: width, height: height });
    }
  }, {
    key: 'validateData',
    value: function validateData(data) {
      data.datasets.forEach(function (item) {
        if (!item.data[0]) {
          item.data.push(0);
        }
      });
      return data;
    }
  }, {
    key: 'updateLineColor',
    value: function updateLineColor(data, fillColor, lineName) {
      var colorScheme = [{ borderColor: '' + _color2.default.blue_main, backgroundColor: '' + _color2.default.blue_main, pointBackgroundColor: '' + _color2.default.y06, pointBorderColor: '' + _color2.default.y06 }, { borderColor: '' + _color2.default.orange_main, backgroundColor: '' + _color2.default.orange_main, pointBackgroundColor: '' + _color2.default.y06, pointBorderColor: '' + _color2.default.y06 }, { borderColor: '' + _color2.default.g10, backgroundColor: '' + _color2.default.g10, pointBackgroundColor: '' + _color2.default.y06, pointBorderColor: '' + _color2.default.y06 }, { borderColor: '' + _color2.default.t2, backgroundColor: '' + _color2.default.t2, pointBackgroundColor: '' + _color2.default.y06, pointBorderColor: '' + _color2.default.y06 }, { borderColor: '' + _color2.default.r12, backgroundColor: '' + _color2.default.r12, pointBackgroundColor: '' + _color2.default.y06, pointBorderColor: '' + _color2.default.y06 }, { borderColor: '' + _color2.default.blue_accent, backgroundColor: '' + _color2.default.blue_accent, pointBackgroundColor: '' + _color2.default.y06, pointBorderColor: '' + _color2.default.y06 }];

      data.datasets.forEach(function (item, ind) {
        if (!item.data[0]) {
          item.data.push(0);
        } else {
          Object.assign(data.datasets[ind], colorScheme[ind], { fill: fillColor }, { label: lineName[ind] });
        }
      });
      return data;
    }
  }, {
    key: 'updateChart',
    value: function updateChart() {
      var _props = this.props,
          data = _props.data,
          options = _props.options,
          legendTemplate = _props.legendTemplate,
          fillColor = _props.fillColor,
          lineName = _props.lineName,
          labelPercentageSymbol = _props.labelPercentageSymbol;

      var totalOptions = Object.assign({
        cornerRadius: 100,
        tooltips: {
          enabled: true,
          backgroundColor: '' + _color2.default.white,
          titleFontColor: '' + _color2.default.blue_main,
          bodyFontColor: '' + _color2.default.grey_main,
          displayColors: false,
          borderColor: 'rgba(64, 55, 136,1)',
          borderWidth: 1,
          cornerRadius: 5,
          xPadding: 10,
          yPadding: 10,
          titleFontSize: 11,
          bodyFontSize: 11
        },
        animation: {
          duration: 0
        },
        legend: {
          display: '' + (data.datasets.length > 1 ? true : false),
          labels: {
            usePointStyle: true
          }
        },
        scales: {
          xAxes: [{
            gridLines: { drawBorder: false, display: false },
            ticks: {
              display: true
            },
            stacked: false
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              display: true,
              color: '' + _color2.default.purple_main,
              zeroLineColor: '' + _color2.default.purple_main
            },
            stacked: false,
            ticks: {
              suggestedMin: 0,
              suggestedMax: 10000,
              display: true,
              userCallback: function userCallback(item) {
                return labelPercentageSymbol ? item / 10000 * 100 + '%' : item;
              }
            }
          }]
        }
      }, options);
      if (this._chart) {
        this._chart.destroy();
      }
      var ctx = this.refs.canvas.getContext('2d');
      this._chart = new this.Chart(ctx, {
        type: "line",
        data: this.updateLineColor(this.validateData(data), fillColor, lineName),
        options: totalOptions,
        legendTemplate: legendTemplate
      });
      this._chart.generateLegend();
    }
  }, {
    key: 'handleChartClick',
    value: function handleChartClick() {
      if (this.props.handleClick !== undefined) {
        this.props.handleClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          wrapperStyle = _props2.wrapperStyle,
          chartBorder = _props2.chartBorder,
          themeId = _props2.themeId;

      var width = this.props.width ? this.props.width : this.state.width;
      var height = this.props.height ? this.props.height : this.state.height;

      return _react2.default.createElement(
        ChartWrapper,
        {
          'data-qa': this.props.testId,
          style: wrapperStyle,
          ref: 'chartWrapper',
          chartBorder: chartBorder,
          onClick: this.handleChartClick.bind(this),
          'data-theme': themeId },
        _react2.default.createElement(
          DivTitle,
          null,
          this.props.title
        ),
        _react2.default.createElement('canvas', { ref: 'canvas', width: width, height: height })
      );
    }
  }]);

  return MozartLineChart;
}(_react.Component);

MozartLineChart.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** chart legend (https://www.chartjs.org/) */
  legendTemplate: _propTypes2.default.string,
  /** data (https://www.chartjs.org/) */
  data: _propTypes2.default.object,
  /** chart width */
  width: _propTypes2.default.number,
  /** chart height */
  height: _propTypes2.default.number,
  /** chart options (https://www.chartjs.org/) */
  options: _propTypes2.default.object,
  /** if responsive chart will scale based on the window width */
  responsive: _propTypes2.default.bool,
  /** chart wrapper style override */
  wrapperStyle: _propTypes2.default.object,
  /** callback when click on chart */
  handleClick: _propTypes2.default.func,
  /** title for chart dispaly on top */
  title: _propTypes2.default.string,
  /** fill color to the line chart */
  fillColor: _propTypes2.default.bool,
  /** list of lines' names */
  lineName: _propTypes2.default.array,
  /** border for the chart */
  chartBorder: _propTypes2.default.bool,
  /** yAxes label */
  labelPercentageSymbol: _propTypes2.default.bool
};
MozartLineChart.defaultProps = {
  fillColor: false,
  chartBorder: true,
  labelPercentageSymbol: false,
  testId: 'MozartLineChart',
  themeId: 'MozartLineChart'
};
exports.default = MozartLineChart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartChart/MozartLineChart/MozartLineChart.js
// module id = 1955
// module chunks = 1